<template>
  <transition name="tooltip">
    <div class="tooltip" :style="{ top, left }" v-if="shown">
      {{ value }}
    </div>
  </transition>
</template>
<script>
import { events } from './bus'

export default {
  name: 'Tooltip',

  data() {
    return {
      visible: false,
      value: '',
      top: '',
      left: '',
      offset: 5
    }
  },

  computed: {
    shown() {
      return this.visible && this.value
    }
  },

  mounted() {
    events.$on('show:hover', this.showEventListener)
    events.$on('hide:hover', this.hideEventListener)
  },

  methods: {
    showEventListener(event) {
      this.$nextTick(() => {
        this.visible = true
        this.value = event.value
        const offset = event.el.getBoundingClientRect()
        this.left = offset.left + 'px'
        this.top = event.el.offsetHeight + offset.top + this.offset + 'px'
      })
    },

    hideEventListener(event) {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .tooltip {
    position: fixed;
    z-index: $z-index--tooltip;
    display: inline-block;
    max-width: 180px;
    padding: 7px 10px;
    background-color: hsla(0, 0%, 32%, 0.8);
    border-radius: 6px/7px;
    color: hsla(0, 0%, 100%, 1);
    font-size: 11px;
    line-height: 15px;
  }

  //
  // Tranistions
  //
  .tooltip-enter-active,
  .tooltip-leave-active {
    transition: transform 150ms ease-in-out;
    transform-origin: 50% 0%;
  }

  .tooltip-enter,
  .tooltip-leave-to {
    transform: scale(0);
  }

  .tootip-leave,
  .tooltip-enter-to {
    transform: scale(1);
  }
</style>



// WEBPACK FOOTER //
// src/plugins/tooltip/Tooltip.vue